import axiosInstance from '@/utils/api.js'

var state = {
  banks: [],
  banks_searched: []
}

var getters = {
  BANKS: (state) => {
    return state.banks
  },
  BANKS_SEARCHED: (state) => {
    return state.banks_searched
  }
}

var mutations = {
  SET_BANKS: (state, payload) => {
    state.banks = payload
  },
  SET_BANKS_SEARCHED: (state, payload) => {
    state.banks_searched = payload
  }
}

var actions = {
  GET_BANKS: async (context, payload) => {
    let result = await axiosInstance.get('/referencebooks/banks')
    if (result.status === 200) {
      context.commit('SET_BANKS', result.data)
    }
  },
  GET_BANKS_SEARCH: async (context, payload) => {
    let result = await axiosInstance.get('/referencebooks/banks_search?page=' + payload.page + '&value=' + payload.value + '&per_page=' + payload.per_page)
    if (result.status === 200) {
      context.commit('SET_BANKS_SEARCHED', result.data)
    }
  },
  CREATE_BANKS: (context, payload) => {
    return axiosInstance.post('/referencebooks/banks', payload)
  },
  UPDATE_BANKS: (context, payload) => {
    return axiosInstance.put('/referencebooks/banks', payload)
  },
  DELETE_BANKS: (context, payload) => {
    return axiosInstance.delete('/referencebooks/banks?bank_id=' + payload.bank_id + '&bic=' + payload.bic)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/referencebooks/banks.js